import cogoToast from 'cogo-toast';
import { useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { useSearchParams } from 'react-router-dom';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfViewer = () => {
  const [numPages, setNumPages] = useState(0);
  const [pageNum, setPageNum] = useState(1);
  const [pdfWidth, setPdfWidth] = useState(getResponsiveWidth());
  const [searchParams] = useSearchParams();

  const pdfLink = searchParams.get("link");

  useEffect(() => {
    const handleResize = () => {
      setPdfWidth(getResponsiveWidth());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getResponsiveWidth() {
    const screenWidth = window.innerWidth;
    if (screenWidth < 600) return screenWidth - 20;      // małe ekrany (telefon)
    if (screenWidth < 1024) return screenWidth - 40;     // tablety
    return 900;                                          // duże ekrany
  }

  const onDocumentLoadSuccess = ({ numPages }) => {
    cogoToast.success(`Załadowano ${numPages} stron`);
    setNumPages(numPages);
    setPageNum(1);
  };

  const goToPrevPage = () => setPageNum((prev) => Math.max(prev - 1, 1));
  const goToNextPage = () => setPageNum((prev) => Math.min(prev + 1, numPages));

  return (
    <div style={{ textAlign: "center", padding: "30px", maxWidth: "100%" }}>
      <h2 style={{ fontSize: "22px", marginBottom: "10px" }}>
        Strona {pageNum} z {numPages}
      </h2>

      <div style={{ marginBottom: "15px", fontSize:"20px" }}>
        <button onClick={goToPrevPage} disabled={pageNum <= 1}>
          ⬅️ Poprzednia
        </button>
        <button
          onClick={goToNextPage}
          disabled={pageNum >= numPages}
          style={{ marginLeft: "10px" }}
        >
          Następna ➡️
        </button>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <Document
          file={pdfLink}
          onLoadSuccess={onDocumentLoadSuccess}
          loading="Ładowanie dokumentu..."
        >
          <Page
            pageNumber={pageNum}
            width={pdfWidth}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </div>
    </div>
  );
};

export default PdfViewer;
